






















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import {
    JumpCard,
    CardIndex,
    HasCard
} from '../../../entities/conversation'
import DropMenu from './DropMenu.vue'
import {
    ContextualData
} from '../ConversationValidator'
import JumpArrow from './JumpArrow.vue'
import {
    Dict
} from '../../../entities/object'


@Component<FlowReturnEditor>({
    components: {
        DropMenu,
        JumpArrow
    }
})
export default class FlowReturnEditor extends Vue {

    @Prop(Object) public card!: JumpCard
    @Prop(Object) public cardIndex!: CardIndex
    @Prop(String) public sectionName!: string

    @Getter public getContextual!: Dict<ContextualData>
    @Getter public getMasterNames!: string[]

    @Action public setCard!: (data: CardIndex & HasCard) => void

    public get options() {
        return this.getMasterNames.filter((name) => name !== 'start')
    }

    public setJump(name: string) {
        this.setCard({
            ...this.cardIndex,
            card:  {
                ...this.card,
                jump: name
            }
        })
    }
}
